import { useQuery } from '@tanstack/react-query';
import type {
  V3ApiSuccessData,
  V3ApiError,
} from 'javascripts/services/v3ApiClient';
import { request } from 'javascripts/services/v3ApiClient';
import { type PageTemplateObject } from 'data/v3/data-contracts';
import { type PageTemplateId } from '../types';

export type GetPageTemplateResponse = V3ApiSuccessData<PageTemplateObject>;

export const PAGE_TEMPLATE_QUERY_KEY = 'PageTemplate';
export type PageTemplateQueryKey = typeof PAGE_TEMPLATE_QUERY_KEY;

export const useGetPageTemplate = ({
  pageTemplateDbId,
}: {
  pageTemplateDbId: PageTemplateId;
}) => {
  const { data, isLoading, error } = useQuery<
    GetPageTemplateResponse,
    V3ApiError
  >({
    queryFn: async () => {
      const response = await request({
        url: `page_templates/${pageTemplateDbId}`,
      });
      return response.data;
    },
    queryKey: [PAGE_TEMPLATE_QUERY_KEY, pageTemplateDbId],
  });

  return {
    pageTemplate: data?.data,
    isLoading,
    error,
  };
};
